import React from "react";

// Perhatikan: Kita pakai "export const" agar import-nya pakai kurung kurawal
export const WhatsApp = () => {
    // 1. Ganti dengan nomor WA Reel Seven (Wajib pakai awalan 62, tanpa + atau 0)
    const phoneNumber = "6285175272114";

    // 2. Pesan otomatis saat klien klik tombolnya
    const message = "Halo Reel Seven Organizer, saya ingin bertanya tentang layanan event...";

    const waLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-float"
            title="Chat via WhatsApp"
        >
            <i className="fa fa-whatsapp"></i>
        </a>
    );
};